/**
 * @generated SignedSource<<2a61da230b1f5549638415a5a6700fdb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_jiraViewResult$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"hierarchyToggle_issueNavigator_HierarchyToggleItem" | "ui_issueTableGroupByDropdown_GroupByDropdown">;
  readonly " $fragmentType": "main_issueNavigator_Header_jiraViewResult";
};
export type main_issueNavigator_Header_jiraViewResult$key = {
  readonly " $data"?: main_issueNavigator_Header_jiraViewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_jiraViewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_jiraViewResult",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
        },
        {
          "kind": "FragmentSpread",
          "name": "ui_issueTableGroupByDropdown_GroupByDropdown"
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};

(node as any).hash = "a96d6f24924a2fbeaf1b9a9899673835";

export default node;
